import { Reducer } from '../../../../@types';
import { AdminsTypes, ClaimsTypes } from '../../../../@types/enums';
import { initialState, ClaimsState } from './initialState';
// @ts-ignore
export const claimsReducer: Reducer<ClaimsState> = (
  state = initialState,
  action
) => {
  switch (action.type as any) {
    case ClaimsTypes.CLAIMS_BY_CAR_REQUEST:
      return {
        ...state,
        isLoadingCarClaim: true,
      };
    case ClaimsTypes.CLAIMS_BY_CAR_SUCCESS:
      return {
        ...state,
        isLoadingCarClaim: false,
      };
    case ClaimsTypes.CLAIMS_BY_CAR_FAILURE:
      return {
        ...state,
        isLoadingCarClaim: false,
      };
    case ClaimsTypes.CLAIMS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ClaimsTypes.CLAIMS_SUCCESS:
      return {
        ...state,
        entities: action.payload,
        loading: false,
      };
    case ClaimsTypes.CLAIM_SUCCESS: {
      const incoming = action.payload;
      // Preserve `events` that may already have been attached by
      // SET_CLAIM_EVENTS while this fetchClaimById was in flight —
      // otherwise the wholesale replacement would wipe them and hide
      // the Feedbacked row.
      const prevEvents =
        state.selected?.id === incoming.id
          ? (state.selected as any)?.events
          : undefined;
      const withEvents = prevEvents
        ? { ...incoming, events: prevEvents }
        : incoming;
      return {
        ...state,
        entities: state?.entities
          ? state.entities.map((entity) =>
              entity.id === incoming.id ? withEvents : entity
            )
          : null,
        display: state?.display
          ? state.display.map((entity) =>
              entity.id === incoming.id ? withEvents : entity
            )
          : null,
        selected: withEvents,
      };
    }
    case ClaimsTypes.CLAIMS_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case ClaimsTypes.SET_TOTAL_DAMAGES:
      return {
        ...state,
        totalDamages: action.payload,
      };
    case ClaimsTypes.SET_DISPLAY_CLAIMS:
      return {
        ...state,
        display: action.payload,
      };
    case ClaimsTypes.SELECT_CLAIM:
      return {
        ...state,
        selected: action.payload,
        claimUserReceipts: null,
      };
    case ClaimsTypes.UPDATE_CLAIM_REQUEST:
      return {
        ...state,
        isUpdating: true,
        updatingStatus: true,
      };
    case ClaimsTypes.UPDATE_CLAIM_SUCCESS: {
      // Update responses may omit initialIgnitionOn, so the derived
      // tripIgnition would flip to "before"; keep the previous value then.
      const updated = (previous: any) =>
        action.payload.initialIgnitionOn || !previous?.tripIgnition
          ? action.payload
          : { ...action.payload, tripIgnition: previous.tripIgnition };
      return {
        ...state,
        isUpdating: false,
        entities: state?.entities?.map((entity) =>
          entity.id === action.payload.id ? updated(entity) : entity
        ),
        display: state?.display?.map((car) =>
          car.id === action.payload.id ? updated(car) : car
        ),
        selected:
          state.selected?.id === action.payload.id
            ? updated(state.selected)
            : state.selected,
        updatingStatus: false,
      };
    }
    case ClaimsTypes.UPDATE_CLAIM_FAILURE:
      return {
        ...state,
        updatingStatus: false,
        isUpdating: false,
        updatingStatusError: action.error,
      };
    case ClaimsTypes.ASSIGNABLE_CLAIM_SUCCESS:
      return {
        ...state,
        assignableClaimTrips: action.payload,
      };
    case ClaimsTypes.CLAIM_USER_RECEIPTS_REQUEST:
      return {
        ...state,
        claimUserReceiptsLoading: true,
      };
    case ClaimsTypes.CLAIM_USER_RECEIPTS_SUCCESS:
      return {
        ...state,
        claimUserReceipts: action.payload,
        claimUserReceiptsLoading: false,
      };
    case ClaimsTypes.CLAIM_USER_RECEIPTS_FAILURE:
      return {
        ...state,
        claimUserReceiptsLoading: false,
      };
    case ClaimsTypes.SET_CLAIM_EVENTS: {
      const { damageId, events } = action.payload;
      const mergeEvents = (claim: any) =>
        claim?.id === damageId ? { ...claim, events } : claim;
      return {
        ...state,
        entities: state?.entities?.map(mergeEvents),
        display: state?.display?.map(mergeEvents),
        selected: mergeEvents(state.selected),
      };
    }
    default:
      return state;
  }
};
